import { Box, Container, Grid2 } from "@mui/material";
import { FaArrowRightLong } from "react-icons/fa6";
import insurtechBadge from "../../../assets/imgs/awards/insurtech100-badge-2026.png";
import insurtechTombstone from "../../../assets/imgs/awards/insurtech100-tombstone-2026.png";

const INSURTECH100_URL = "https://www.TheInsurTech100.com";

export const InsurTechBadge = () => {
  return (
    <Box
      className="w-full relative overflow-hidden"
      sx={{
        background:
          "radial-gradient(ellipse 80% 70% at 12% 50%, rgba(2, 23, 68, 0.05) 0%, transparent 55%), radial-gradient(ellipse 60% 50% at 90% 80%, rgba(0, 153, 176, 0.08) 0%, transparent 50%), linear-gradient(rgba(2,23,68,0.02) 1px, transparent 1px), linear-gradient(90deg, rgba(2,23,68,0.02) 1px, transparent 1px), #F7F9FC",
        backgroundSize: "auto, auto, 40px 40px, 40px 40px, auto",
      }}
    >
      {/* Soft ring motif echoing the badge, decorative only */}
      <Box
        aria-hidden="true"
        sx={{
          display: { xs: "none", sm: "block" },
          pointerEvents: "none",
          position: "absolute",
          width: { xs: 280, md: 420 },
          height: { xs: 280, md: 420 },
          borderRadius: "50%",
          border: "1px solid rgba(124, 92, 168, 0.2)",
          top: { xs: -80, md: "50%" },
          left: { xs: -100, md: -60 },
          transform: { md: "translateY(-50%)" },
        }}
      />
      <Box
        aria-hidden="true"
        sx={{
          display: { xs: "none", sm: "block" },
          pointerEvents: "none",
          position: "absolute",
          width: { xs: 200, md: 300 },
          height: { xs: 200, md: 300 },
          borderRadius: "50%",
          border: "1px solid rgba(2, 23, 68, 0.1)",
          top: { xs: -40, md: "50%" },
          left: { xs: -60, md: 20 },
          transform: { md: "translateY(-42%)" },
        }}
      />

      <Container maxWidth="lg">
        <Box className="w-full" sx={{ py: { xs: 6, sm: 9, md: 14 } }}>
          <Grid2
            container
            spacing={{ xs: 5, sm: 6, md: 8 }}
            alignItems="center"
            justifyContent="center"
          >
            <Grid2 size={{ xs: 12, md: 5 }}>
              <Box
                data-aos-duration="1000"
                data-aos="fade-right"
                className="w-full"
                sx={{
                  display: "flex",
                  justifyContent: { xs: "center", md: "flex-start" },
                }}
              >
                <Box
                  sx={{
                    position: "relative",
                    width: { xs: 210, sm: 280, md: 350 },
                    maxWidth: "90%",
                    isolation: "isolate",
                    "&::before": {
                      content: '""',
                      position: "absolute",
                      inset: 0,
                      borderRadius: "20px",
                      background:
                        "linear-gradient(145deg, rgba(124,92,168,0.32), rgba(0,153,176,0.18))",
                      transform: "rotate(-5deg)",
                      zIndex: -1,
                    },
                  }}
                >
                  <Box
                    component="a"
                    href={INSURTECH100_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="View Charlee.ai on The InsurTech100 2026"
                    sx={{
                      display: "block",
                      borderRadius: "18px",
                      overflow: "hidden",
                      background: "#FFFFFF",
                      border: "1px solid rgba(2,23,68,0.08)",
                      boxShadow:
                        "0 0 0 1px rgba(2,23,68,0.08), 0 24px 48px rgba(2,23,68,0.18)",
                      transition: "transform 0.35s ease, box-shadow 0.35s ease",
                      "&:hover": {
                        transform: "translateY(-4px)",
                        boxShadow:
                          "0 0 0 1px rgba(124, 92, 168, 0.45), 0 28px 56px rgba(2,23,68,0.24)",
                      },
                    }}
                  >
                    <img
                      src={insurtechTombstone}
                      alt="Charlee.ai is an InsurTech100 company for 2026"
                      width={700}
                      height={879}
                      loading="lazy"
                      className="w-full h-auto block"
                    />
                  </Box>
                </Box>
              </Box>
            </Grid2>

            <Grid2 size={{ xs: 12, md: 7 }}>
              <Box
                data-aos-duration="1000"
                data-aos="fade-left"
                className="w-full"
                sx={{
                  position: "relative",
                  px: { xs: 1, sm: 0 },
                  pr: { lg: 20 },
                  textAlign: { xs: "center", md: "left" },
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: { xs: "center", md: "flex-start" },
                    gap: 1.5,
                  }}
                >
                  <Box sx={{ width: 32, height: 2, background: "#7C5CA8" }} />
                  <p className="uppercase font-semibold tracking-wide text-[#7C5CA8] text-[14px] leading-[15.96px]">
                    Recognition
                  </p>
                </Box>
                <Box
                  component="h2"
                  sx={{
                    mt: { xs: 2, md: 3 },
                    color: "#021744",
                    fontSize: { xs: 28, sm: 34, md: 42 },
                    lineHeight: { xs: "36px", sm: "44px", md: "54.6px" },
                    fontWeight: 500,
                  }}
                >
                  Named to the InsurTech100 for 2026
                </Box>
                <Box
                  component="p"
                  sx={{
                    mt: { xs: 2, md: 3 },
                    mx: { xs: "auto", md: 0 },
                    maxWidth: 576,
                    color: "#4B5563",
                    fontSize: { xs: 15, sm: 16, md: 18 },
                    lineHeight: { xs: "26px", sm: "28px", md: "30px" },
                  }}
                >
                  Charlee.ai has been selected for FinTech Global’s ninth annual
                  InsurTech100 — recognising the companies shaping the future of
                  insurance through technology.
                </Box>

                <Box
                  display="flex"
                  flexDirection={{ xs: "column", sm: "row" }}
                  alignItems="center"
                  justifyContent={{ xs: "center", md: "flex-start" }}
                  gap={2}
                  sx={{ width: "100%", mt: { xs: 3, md: 4 } }}
                >
                  <Box
                    sx={{
                      display: "inline-flex",
                      alignItems: "center",
                      px: 2,
                      py: 1,
                      borderRadius: "9999px",
                      border: "1px solid #7C5CA8",
                      background: "#7C5CA8",
                      color: "#FFFFFF",
                      fontSize: "13px",
                      fontWeight: 600,
                      letterSpacing: "0.04em",
                      textTransform: "uppercase",
                      justifyContent: "center",
                      width: { xs: "100%", sm: "auto" },
                      maxWidth: { xs: 280, sm: "none" },
                    }}
                  >
                    InsurTech100 · 2026
                  </Box>
                  <a
                    href={INSURTECH100_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex w-full max-w-[280px] items-center justify-center rounded-full border border-[#021744] px-5 py-2.5 font-medium text-[16px] text-[#021744] transition-colors hover:bg-[#021744] hover:text-white group sm:w-auto md:text-[18px]"
                  >
                    Explore the list
                    <FaArrowRightLong className="mx-3 transition-transform group-hover:translate-x-1" />
                  </a>
                </Box>

                <Box
                  component="a"
                  href={INSURTECH100_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Visit The InsurTech100 2026"
                  sx={{
                    position: { xs: "relative", lg: "absolute" },
                    display: "block",
                    width: { xs: 125, sm: 135, lg: 140 },
                    ml: "auto",
                    mr: { xs: "auto", md: 0 },
                    mt: { xs: 7, md: 5, lg: 0 },
                    top: { lg: 0 },
                    right: { lg: 0 },
                    p: "5px",
                    borderRadius: "22px",
                    background:
                      "linear-gradient(145deg, #FFFFFF 15%, #E8DDF0 55%, #D9F1F3 100%)",
                    boxShadow:
                      "0 18px 38px rgba(2,23,68,0.2), 0 0 0 1px rgba(124,92,168,0.14)",
                    transition: "transform 0.35s ease, box-shadow 0.35s ease",
                    "&::after": {
                      content: '""',
                      position: "absolute",
                      inset: -9,
                      borderRadius: "28px",
                      border: "1px dashed rgba(124,92,168,0.35)",
                      pointerEvents: "none",
                    },
                    "&::before": {
                      content: '"Official badge"',
                      display: { xs: "block", lg: "none" },
                      position: "absolute",
                      top: { xs: "auto", md: "50%" },
                      right: { xs: "50%", md: "calc(100% + 18px)" },
                      bottom: { xs: "calc(100% + 10px)", md: "auto" },
                      transform: {
                        xs: "translateX(50%)",
                        md: "translateY(-50%)",
                      },
                      color: "#667085",
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.08em",
                      textTransform: "uppercase",
                      whiteSpace: "nowrap",
                    },
                    "&:hover": {
                      transform: "translateY(-5px) rotate(2deg)",
                      boxShadow:
                        "0 24px 46px rgba(2,23,68,0.25), 0 0 0 1px rgba(124,92,168,0.28)",
                    },
                  }}
                >
                  <img
                    src={insurtechBadge}
                    alt="Official InsurTech100 2026 badge"
                    width={280}
                    height={280}
                    loading="lazy"
                    className="w-full h-auto block rounded-[17px]"
                  />
                </Box>
              </Box>
            </Grid2>
          </Grid2>
        </Box>
      </Container>
    </Box>
  );
};
